import type { MessageKey } from './messages';
import type { TranslateParams } from './translate';

export type TranslateFn = (key: MessageKey, params?: TranslateParams) => string;

export type LabeledOperation<T extends string> = { value: T; label: string };

export function assetOperations(t: TranslateFn): LabeledOperation<'getById' | 'listMine' | 'active' | 'create'>[] {
  return [
    { value: 'getById', label: t('assets.operation.getById') },
    { value: 'listMine', label: t('assets.operation.listMine') },
    { value: 'active', label: t('assets.operation.active') },
    { value: 'create', label: t('assets.operation.create') },
  ];
}

export function assetOperationSelectLabel(
  op: LabeledOperation<'getById' | 'listMine' | 'active' | 'create'>,
  canMutateAssets: boolean,
  t: TranslateFn,
): string {
  if (canMutateAssets) {
    return op.label;
  }
  switch (op.value) {
    case 'active':
      return t('assets.book.available');
    case 'getById':
      return t('assets.book.view');
    default:
      return op.label;
  }
}

export function bookingOperations(
  t: TranslateFn,
): LabeledOperation<
  | 'getById'
  | 'listAll'
  | 'create'
  | 'modifyPrice'
  | 'cancelClient'
  | 'cancelOwner'
  | 'escalate'
>[] {
  return [
    { value: 'getById', label: t('bookings.operation.getById') },
    { value: 'listAll', label: t('bookings.operation.listAll') },
    { value: 'create', label: t('bookings.operation.create') },
    { value: 'modifyPrice', label: t('bookings.operation.modifyPrice') },
    { value: 'cancelClient', label: t('bookings.operation.cancelClient') },
    { value: 'cancelOwner', label: t('bookings.operation.cancelOwner') },
    { value: 'escalate', label: t('bookings.operation.escalate') },
  ];
}

export function profileOperations(
  t: TranslateFn,
): LabeledOperation<
  | 'getProfile'
  | 'listWorkers'
  | 'registerWorker'
  | 'patchProfile'
  | 'changePassword'
  | 'deactivate'
>[] {
  return [
    { value: 'getProfile', label: t('profile.operation.getProfile') },
    { value: 'listWorkers', label: t('profile.operation.listWorkers') },
    { value: 'registerWorker', label: t('profile.operation.registerWorker') },
    { value: 'patchProfile', label: t('profile.operation.patchProfile') },
    { value: 'changePassword', label: t('profile.operation.changePassword') },
    { value: 'deactivate', label: t('profile.operation.deactivate') },
  ];
}
